import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var colorImageSchema = {
    image_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
            noClose: true
        }),
        elementType: 'image',
        label: 'Цветова картинка',
        value: null,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна цветова картинка',
    }),
};
export default colorImageSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/colorImageSchema.ts
// module id = 339
// module chunks = 0